import { enqueueSnackbar } from 'notistack';

// utils/getLocation.js
export const getLocation = () => {
  return new Promise((resolve, reject) => {
    const DUMMY_LOCATION = [22.998089, 72.502796];
    if (!navigator.geolocation) {
      return reject(new Error('Geolocation not supported'));
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        resolve([latitude, longitude]);
      },
      (error) => {
        if (error.code === 1) {
          enqueueSnackbar('Location permission denied ', {
            variant: 'error',
            autoHideDuration: 3000,
          });
        } else if (error.code === 2) {
          enqueueSnackbar('Location unavailable', {
            variant: 'error',
            autoHideDuration: 3000,
          });
        } else if (error.code === 3) {
          enqueueSnackbar('Location request timed out', {
            variant: 'error',
            autoHideDuration: 3000,
          });
        }
        resolve(DUMMY_LOCATION);
        // reject(error);
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      },
    );
  });
};
